import { action } from "@ember/object"
import Component from "@glimmer/component"
import styles from "./full-screen-menu.module.css"

export default class FullScreenMenuComponent extends Component {
  readonly styles = styles

  @action
  addBodyClass() {
    if (document && document.body) {
      document.body.classList.add("full-screen-modal-open")
    }
  }

  @action
  removeBodyClass() {
    if (document && document.body) {
      document.body.classList.remove("full-screen-modal-open")
    }
  }
}
